export default __webpack_public_path__ + "static/media/avatar-2.75d8f23e.png";